import { useAuth } from "../contexts/AuthContext";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, FileText, CalendarDays, UserCircle, ShieldCheck, LogOut, FolderOpen } from "lucide-react";
import { Button } from "./ui/button";
import { Separator } from "./ui/separator";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/payslips", label: "Abrechnungen", icon: FileText },
  { to: "/vacation", label: "Urlaub", icon: CalendarDays },
  { to: "/documents", label: "Dokumente", icon: FolderOpen },
  { to: "/personal-data", label: "Meine Daten", icon: UserCircle },
];
const adminItems = [{ to: "/admin", label: "Verwaltung", icon: ShieldCheck }];

export const AppLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";
  const allItems = isAdmin ? [...navItems, ...adminItems] : navItems;
  const handleLogout = () => { logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-slate-50">
      <aside className="hidden md:flex flex-col w-64 bg-slate-900 text-white h-screen fixed left-0 top-0 z-40">
        <div className="p-6">
          <h1 className="font-heading font-bold text-xl tracking-tight uppercase text-white">VPE Personal</h1>
          <p className="text-xs text-slate-400 font-body mt-1">Mitarbeiterportal</p>
        </div>
        <Separator className="bg-slate-700" />
        <nav className="flex-1 p-4 space-y-1">
          {allItems.map((item) => (
            <NavLink key={item.to} to={item.to}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg font-heading text-sm uppercase tracking-wide ${isActive ? "bg-blue-600 text-white" : "text-slate-300 hover:text-white hover:bg-slate-800"}`}>
              <item.icon className="w-5 h-5" strokeWidth={1.5} />{item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-slate-700">
          <div className="flex items-center gap-3 px-4 py-2">
            <div className="w-8 h-8 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-sm">
              {user?.first_name?.[0]}{user?.last_name?.[0]}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">{user?.first_name} {user?.last_name}</p>
              <p className="text-xs text-slate-400 truncate">{user?.personnel_number}</p>
            </div>
          </div>
          <Button variant="ghost" onClick={handleLogout}
            className="w-full mt-2 justify-start gap-3 text-slate-300 hover:text-white hover:bg-slate-800 font-heading text-sm uppercase tracking-wide">
            <LogOut className="w-5 h-5" strokeWidth={1.5} />Abmelden
          </Button>
        </div>
      </aside>
      <header className="md:hidden fixed top-0 left-0 right-0 bg-white border-b border-slate-200 h-[calc(3.5rem_+_env(safe-area-inset-top))] pt-[env(safe-area-inset-top)] flex items-center justify-between px-4 z-40">
        <h1 className="font-heading font-bold text-lg tracking-tight text-slate-900 uppercase">VPE Portal</h1>
        <Button variant="ghost" size="sm" onClick={handleLogout}><LogOut className="w-5 h-5 text-slate-500" strokeWidth={1.5} /></Button>
      </header>
      <main className="md:ml-64 pt-[calc(3.5rem_+_env(safe-area-inset-top))] md:pt-0 pb-[calc(5rem_+_env(safe-area-inset-bottom))] md:pb-8">
        <div className="p-4 md:p-8 max-w-5xl mx-auto"><Outlet /></div>
      </main>
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 h-[calc(4rem_+_env(safe-area-inset-bottom))] pb-[env(safe-area-inset-bottom)] flex items-center justify-around z-50">
        {allItems.slice(0, 5).map((item) => (
          <NavLink key={item.to} to={item.to}
            className={({ isActive }) => `flex flex-col items-center gap-1 py-1 px-2 ${isActive ? "text-blue-600" : "text-slate-400"}`}>
            <item.icon className="w-5 h-5" strokeWidth={1.5} />
            <span className="text-[10px] font-heading uppercase tracking-wide">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};
